import defaultBackground from '../../assets/home/masterCardBg.jpg';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { shopifyCDNFile } from 'lib/shopifyImageSizer';

interface BannerProps {
  children?: React.ReactNode;
  imageSrc?: string;
  maxHeight?: string;
}

const useStyles = ({ maxHeight }: { maxHeight?: string }) =>
  makeStyles((theme: Theme) => ({
    root: {
      position: 'relative',
      height: `calc(100vh - 60px)`,
      minHeight: '500px',
      maxHeight: maxHeight,
    },
    background: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      backgroundSize: 'cover',
      zIndex: -1,
      bottom: '-5px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
  }));

const Banner: React.FC<BannerProps> = (props) => {
  const classes = useStyles({ maxHeight: props.maxHeight })();
  return (
    <div className={classes.root}>
      <div
        className={classes.background}
        style={{
          backgroundImage: `url(${props.imageSrc ? shopifyCDNFile(props.imageSrc) : defaultBackground})`,
        }}
      ></div>
      {props.children}
    </div>
  );
};

export default Banner;
